const getIsLegacyChunk = () => import.meta.env.LEGACY;

export default getIsLegacyChunk;
